import { render, staticRenderFns } from "./TransferStaff.vue?vue&type=template&id=56801f36&"
import script from "./TransferStaff.vue?vue&type=script&lang=js&"
export * from "./TransferStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports